import { DropdownVATOptions, getVatPercentageForDropdownVAT } from '../../../../../types/enums.ts';
import type { Money } from '../../../../../lib/Money.ts';
import type {Unit} from '../../../../../generated/enums.ts';


export {
    CATALOG_UNIT_LABELS,
    CATALOG_UNIT_OPTIONS,
    VAT_SHORT_LABELS,
} from '../../../../../types/catalogue.ts';
export type { CatalogItem } from '../../../../../types/catalogue.ts';

export type CatalogItemFormValues = {
    name: string;
    unit_price: Money | null;
    unit: Unit;
    vat_option: DropdownVATOptions;
};

export function computePriceIncludingVatCents(
    unitPriceCents: number,
    vatOption: DropdownVATOptions,
): number | null {
    const percentage = getVatPercentageForDropdownVAT(vatOption);
    if (percentage === null) {
        return null;
    }
    return Math.round(unitPriceCents * (1 + percentage / 100));
}
